import { Button, type ButtonProps } from "../../button/button";
import { cn } from "../../../lib/utils";

export interface LabStatusFilterChipProps extends Omit<ButtonProps, "variant" | "children"> {
  label: string;
  count: number;
  active: boolean;
  colorClass: string;
  activeColorClass: string;
}

export const LabStatusFilterChip = ({
  label,
  count,
  active,
  colorClass,
  activeColorClass,
  className,
  ...props
}: LabStatusFilterChipProps) => {
  return (
    <Button
      data-slot="lab-status-filter-chip"
      variant={active ? "chip-active" : "chip"}
      size="default"
      className={cn("gap-2", active && activeColorClass, className)}
      {...props}
    >
      <div className={cn("w-2 h-2 rounded-full", colorClass)} />
      <span>{label}</span>
      <span className="text-xs opacity-75">{count}</span>
    </Button>
  );
};
